module.exports = {

    // 马上代驾，白师傅，羚师傅代驾，九州代驾都是用这一版程序，功能同步更新，切换下面的配置即可切换项目，不同项目主题色不同，文字不同，都是动态的
    // 宝塔
    // 九州代驾宝塔测试环境: https://120.46.153.150:8888/3d2df085
    // 用户名：lhucebt8
    // 密码：5878c243

    // 九州代驾宝塔线上：http://124.70.4.204:8888/d02f5983
    // 用户名：ylxs0maj
    // 密码：46ab94fe

    // 羚师傅，白师傅，一个宝塔 就一个环境，是线上
    // 外网：https://116.205.123.108:35958/aa5a324e
    // 内网：https://192.168.0.65:35958/aa5a324e
    // 用户名：2smc2zqx
    // 密码：f794e093








    // 九州代驾测试
    config: {
        'localStorage_token_name': 'access_token',
        'axios_timeout': 20000, // 请求超时时间20秒
        'axios_baseURL': 'https://9ztest.v3.jiuzhoudaijiaapi.cn',
        'axios_normalURL': 'https://normaltest.v3.jiuzhoudaijiaapi.cn',
        'axios_imgURL': 'https://normaltest.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
        'hash_key': 'gcss9csffhhc9z',
        'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
        // 九州代驾
        'proType': '九州',
        'proColor': '#05c0ab',
        'proTheme': 'index1.css',
        'backgroundImage': 'new.png',


        // 马上代驾 背景图用九州的
        // 'proType': '马上',
        // // 'proColor': '#01c0ab', // 马上主题色，马上的因为element ui 主题色功能不好使，所以主题色暂用九州的，因为跟九州颜色基本一致
        // 'proColor': '#05c0ab', // 九州的主题色
        // 'proTheme': 'ling.css',
        // 'backgroundImage': 'new.png',

        // 'webSocket': 'ws://192.168.100.9:9505?',
        'webSocket': 'wss://sockettest.v3.jiuzhoudaijiaapi.cn:9505?',
        'h5': 'https://h5test.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    }


    // ----------------------------------------- v3 -----------------------------------------

    // 九州代驾线上
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9z.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normal.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normal.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     // 九州代驾
    //     'proType': '九州',
    //     'proColor': '#05c0ab',
    //     'proTheme': 'index1.css',
    //     'backgroundImage': 'new.png',


    //     // // 马上代驾 背景图用九州的
    //     // 'proType': '马上',
    //     // 'proColor': '#01c0ab',
    //     // 'proTheme': 'ling.css',
    //     // 'backgroundImage': 'new.png',

    //     'hash_key': 'gcss9csffhhc9z',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socket.v3.jiuzhoudaijiaapi.cn:9505?',
    //     'h5': 'https://h5.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }


    // ----------------------------------------- v3 -----------------------------------------

    //九州代驾 Dev2 农行支付测试环境环境

    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9zdev2.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normaldev2.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normaldev2.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //
    // 九州代驾
    // 'proType': '九州',
    // 'proColor': '#05c0ab',
    // 'proTheme': 'index1.css',
    // 'backgroundImage': 'new.png',


    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketdev2.v3.jiuzhoudaijiaapi.cn:9510?',
    //     'h5': 'https://h5.v3.dev2.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }

    // ----------------------------------------- v3 -----------------------------------------

    // 九州代驾 dev 环境
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9zdev.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normaldev.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normaldev.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    // 九州代驾
    // 'proType': '九州',
    // 'proColor': '#05c0ab',
    // 'proTheme': 'index1.css',
    // 'backgroundImage': 'new.png',


    //     'hash_key': 'gcss9csffhhc9z',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketdev.v3.jiuzhoudaijiaapi.cn:9506?',
    //     'h5': 'https://h5.v3.dev.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }


    // ----------------------------------------- v3 -----------------------------------------
    // 九州代驾 alipay.trade.query  测试环境
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9z1.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normal1.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normal1.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey':'7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     // 九州代驾
    // 'proType': '九州',
    // 'proColor': '#05c0ab',
    // 'proTheme': 'index1.css',
    // 'backgroundImage': 'new.png',


    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socket1.v3.jiuzhoudaijiaapi.cn:9508?',
    //     'h5': 'https://h5.v3.1.jiuzhouapi.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }




    // ----------------------------------------- v3 -----------------------------------------

    // 九州代驾 测试故障
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9za.v3.jiuzhoudaijiaapi.cn ',
    //     'axios_normalURL': 'https://normala.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normala.v3.jiuzhoudaijiaapi.cn/qiniu/upload',
    //     'qnKey':'7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //      // 九州代驾
    // 'proType': '九州',
    // 'proColor': '#05c0ab',
    // 'proTheme': 'index1.css',
    // 'backgroundImage': 'new.png',

    //     'hash_key': 'gcss9csffhhc9z',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketa.v3.jiuzhoudaijiaapi.cn:9505?',
    //     'h5': 'https://h5a.v3.jiuzhoudaijiaapi.cn/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }

    // ----------------------------------------- v3 -----------------------------------------


    // // 陕西羚师傅代驾线上
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9z.anxingtech.com',
    //     'axios_normalURL': 'https://normal.anxingtech.com',
    //     'axios_imgURL': 'https://normal.anxingtech.com/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',


    //     'proType': '羚师傅',
    //     'proColor': '#0EC879',
    //     'proTheme': 'ling.css',
    //     'backgroundImage': 'ling.png',

    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socket.anxingtech.com:9505?',
    //     'h5': 'https://h5.anxingtech.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }




    // ----------------------------------------- v3 -----------------------------------------

    // 白师傅代驾线上 只有这一个环境
    // config: {
    //     'localStorage_token_name': 'access_token',
    //     'axios_timeout': 20000, // 请求超时时间20秒
    //     'axios_baseURL': 'https://9zbai.v3.jiuzhoudaijiaapi.cn',
    //     'axios_normalURL': 'https://normalbai.v3.jiuzhoudaijiaapi.cn',
    //     'axios_imgURL': 'https://normal.anxingtech.com/qiniu/upload',
    //     'hash_key': 'gcss9csffhhc9z',
    //     'qnKey': '7KhrRruiqd6r3UM5IfMlKUWbyDCbo14bNw5HDbQ2',
    //     'proType': '白师傅',

    //     // 白师傅和羚师傅主题色相同 背景图相同 'proType': '白师傅',
    //     'proColor': '#0EC879',
    //     'proTheme': 'ling.css',
    //     'backgroundImage': 'ling.png',
    //     // 'webSocket': 'ws://192.168.100.9:9505?',
    //     'webSocket': 'wss://socketbai.v3.jiuzhoudaijiaapi.cn:9506?',
    //     'h5': 'https://h5.anxingtech.com/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code='
    // }

    // ----------------------------------------- v3 -----------------------------------------









}